import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { key: 2 }
const _hoisted_3 = {
  key: 1,
  class: "empty-state"
}

import { IonContent, IonFab, IonFabButton, IonHeader, IonIcon, IonMenuButton, IonPage, IonReorderGroup, IonTitle, IonToolbar, onIonViewDidLeave, onIonViewDidEnter } from '@ionic/vue';
import { addOutline, saveOutline, balloonOutline } from 'ionicons/icons';
import RuleItem from '@/components/RuleItem.vue';
import { useRouter } from "vue-router";
import ScheduleRuleItem from '@/components/ScheduleRuleItem.vue';
import { useStore } from 'vuex';
import { computed, ref } from 'vue';
import { translate } from '@hotwax/dxp-components';
import emitter from '@/event-bus';
import { RuleService } from '@/services/RuleService';
import { doReorder, showToast } from '@/utils';
import ArchivedRuleItem from '@/components/ArchivedRuleItem.vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'SafetyStock',
  setup(__props) {

const store = useStore();
const router = useRouter()

const rules = computed(() => store.getters["rule/getRules"]);
const ruleGroup = computed(() => store.getters["rule/getRuleGroup"]);
const isReorderActive = computed(() => store.getters["rule/isReorderActive"]);
const archivedRules = computed(() => store.getters["rule/getArchivedRules"]);
const reorderingRules = ref([]);

onIonViewDidEnter(async() => {
  fetchRules();
  emitter.on("productStoreOrConfigChanged", fetchRules);
})

onIonViewDidLeave(() => {
  emitter.off("productStoreOrConfigChanged", fetchRules);
  store.dispatch("rule/updateIsReorderActive", false)
})

async function fetchRules() {
  emitter.emit("presentLoader");
  store.dispatch("util/updateSelectedSegment", "");
  store.dispatch("rule/updateIsReorderActive", false)
  await Promise.allSettled([store.dispatch('rule/fetchRules', { groupTypeEnumId: 'RG_SAFETY_STOCK', pageSize: 50 }), store.dispatch("util/fetchConfigFacilities"), store.dispatch("util/fetchFacilityGroups")]);
  emitter.emit("dismissLoader");
}

function activateReordering() {
  store.dispatch("rule/updateIsReorderActive", true)
  reorderingRules.value = rules.value;
}

async function saveReorder() {
  const diffRules = reorderingRules.value.filter((reorderRule: any) => rules.value.some((rule: any) => rule.ruleId === reorderRule.ruleId && rule.sequenceNum !== reorderRule.sequenceNum))
  if(!diffRules.length) {
    store.dispatch("rule/updateIsReorderActive", false)
    showToast(translate("No sequence has been changed."))
    return;
  }

  emitter.emit("presentLoader", { messgae: "Saving changes.." })
  const responses = await Promise.allSettled(diffRules.map(async (rule: any) => {
    await RuleService.updateRule(rule, rule.ruleId)
  }))

  const isFailedToUpdateSomeRule = responses.some((response) => response.status === 'rejected')
  if(isFailedToUpdateSomeRule) {
    showToast(translate("Failed to update sequence for some rules."))
  } else {
    showToast(translate("Sequence for rules updated successfully."))
  }
  emitter.emit("dismissLoader");
  await store.dispatch('rule/updateRules', { rules: reorderingRules.value })
  store.dispatch("rule/updateIsReorderActive", false)
}

function updateReorderingRules(event: any) {
  reorderingRules.value = doReorder(event, reorderingRules.value)
}

function createRule() {
  router.push({ path: '/create-safety-stock' })
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(IonPage), null, {
    default: _withCtx(() => [
      _createVNode(_unref(IonHeader), { translucent: true }, {
        default: _withCtx(() => [
          _createVNode(_unref(IonToolbar), null, {
            default: _withCtx(() => [
              _createVNode(_unref(IonMenuButton), { slot: "start" }),
              _createVNode(_unref(IonTitle), null, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref(translate)("Safety stock")), 1)
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_unref(IonContent), null, {
        default: _withCtx(() => [
          (ruleGroup.value.ruleGroupId && (rules.value.length || archivedRules.value.length))
            ? (_openBlock(), _createElementBlock("main", _hoisted_1, [
                (rules.value.length)
                  ? (_openBlock(), _createBlock(ScheduleRuleItem, { key: 0 }))
                  : _createCommentVNode("", true),
                (archivedRules.value?.length)
                  ? (_openBlock(), _createBlock(ArchivedRuleItem, { key: 1 }))
                  : _createCommentVNode("", true),
                (rules.value.length)
                  ? (_openBlock(), _createElementBlock("section", _hoisted_2, [
                      _createVNode(_unref(IonReorderGroup), {
                        disabled: false,
                        onIonItemReorder: _cache[0] || (_cache[0] = ($event: any) => (updateReorderingRules($event)))
                      }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList((isReorderActive.value ? reorderingRules.value : rules.value), (rule, ruleIndex) => {
                            return (_openBlock(), _createBlock(RuleItem, {
                              rule: rule,
                              ruleIndex: ruleIndex,
                              key: rule.ruleId
                            }, null, 8, ["rule", "ruleIndex"]))
                          }), 128))
                        ]),
                        _: 1
                      })
                    ]))
                  : _createCommentVNode("", true)
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_3, [
                _createElementVNode("p", null, _toDisplayString(_unref(translate)("No safety stock rule found.")), 1)
              ]))
        ]),
        _: 1
      }),
      _createVNode(_unref(IonFab), {
        vertical: "bottom",
        horizontal: "end",
        slot: "fixed",
        class: "ion-margin"
      }, {
        default: _withCtx(() => [
          _createVNode(_unref(IonFabButton), {
            disabled: !rules.value.length,
            class: "ion-margin-bottom",
            color: "light",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (isReorderActive.value ? saveReorder() : activateReordering()))
          }, {
            default: _withCtx(() => [
              _createVNode(_unref(IonIcon), {
                icon: isReorderActive.value ? _unref(saveOutline) : _unref(balloonOutline)
              }, null, 8, ["icon"])
            ]),
            _: 1
          }, 8, ["disabled"]),
          _createVNode(_unref(IonFabButton), {
            disabled: isReorderActive.value,
            onClick: _cache[2] || (_cache[2] = ($event: any) => (createRule()))
          }, {
            default: _withCtx(() => [
              _createVNode(_unref(IonIcon), { icon: _unref(addOutline) }, null, 8, ["icon"])
            ]),
            _: 1
          }, 8, ["disabled"])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})